<script lang="ts">
  import {clickOutside, isSafari} from '@/utils/common';
  import {createEventDispatcher} from 'svelte';
  import type {PreviewImage} from '@/types/common';
  import tippy from 'tippy.js';
  import WrapperModal from '@/components/modals/WrapperModal.svelte';
  import {user} from '@/store';
  import {MemberShipType} from '@/types/user';
  import FeatureFlag from '@/platform-redesign-components/FeatureFlag.svelte';

  export let item: PreviewImage;
  export let selected: PreviewImage;
  const dispatch = createEventDispatcher();
  let placeholder: Element;
  const isAdmin = window.uData && window.uData.is_admin;
  const loadImage = () => {
    if (placeholder) placeholder.remove();
    dispatch('image-load');
  };

  let devalueLevel = 0;

  const toggleFavorite = (item: PreviewImage) => {
    dispatch('set-favorite');
  };

  const toggleFeature = (item: PreviewImage) => {
    dispatch('feature-click');
  };

  let favoriteTooltip: HTMLElement;
  let unFavoriteTooltip: HTMLElement;

  $: {
    if (favoriteTooltip) {
      tippy(favoriteTooltip, {
        theme: 'light',
        content: `<div class="flex flex-col p-2 items-center justify-center">
                    <span class="inline-block align-middle font-light">Add to Favorites</span>
                </div>`,
        allowHTML: true,
        placement: 'right'
      });
    }
    if (unFavoriteTooltip) {
      tippy(unFavoriteTooltip, {
        theme: 'light',
        content: `<div class="flex flex-col p-2 items-center justify-center">
                    <span class="inline-block align-middle font-light">Remove from Favorites</span>
                </div>`,
        allowHTML: true,
        placement: 'right'
      });
    }
  }
</script>

<FeatureFlag>
  <div
    slot="new_component"
    class="image-item relative flex w-1/4 cursor-pointer flex-col gap-2 text-ellipsis p-2 {isAdmin
      ? 'hover:bg-gray-200'
      : ''}"
  >
    <div
      class="relative h-full w-full rounded-xl {selected.id === item.id
        ? 'shadow-lg outline outline-4 outline-primary'
        : ''}"
      data-template-id={item.id}
    >
      <img
        alt={item.title}
        src={item.src}
        loading="lazy"
        on:load={loadImage}
        on:click={() => dispatch('image-click')}
        on:keydown={() => dispatch('image-click')}
        data-id={item.id}
        id="image-item-{item.id}"
        use:clickOutside
        class="relative z-10 h-full w-full rounded-xl"
      />
      <button
        on:click={() => toggleFavorite(item)}
        id="toggle_favorite"
        class="absolute right-2 top-2 z-20 rounded-full border-0 p-2"
      >
        {#if item.isFavorite == false}
          <span bind:this={favoriteTooltip}>
            <i class="fa-regular fa-star text-2xl text-[#FABE24]" />
          </span>
        {/if}
        {#if item.isFavorite == true}
          <span bind:this={unFavoriteTooltip}>
            <i class="fa-solid fa-star text-2xl text-[#FABE24]" />
          </span>
        {/if}
      </button>
      {#if isAdmin}
        <details class="absolute bottom-2 right-2 z-30 mr-2">
          <summary>
            <i class="fa-solid fa-ellipsis-vertical text-2xl text-[#FABE24]" />
          </summary>
          <div class="absolute grid justify-stretch rounded-md bg-white p-6 shadow-sm" role="group">
            <div class="grid grid-flow-col gap-1">
              <button
                on:click={() => dispatch('admin-click')}
                class="rounded-md border-2 border-gray-700 px-4 py-1 text-sm font-medium text-gray-700 hover:bg-red-400 hover:text-white"
              >
                Delete Template
              </button>
              <button
                on:click={() => toggleFeature(item)}
                class="text rounded-md border-2 border-gray-700 px-4 py-1 text-sm font-medium hover:bg-red-400 hover:text-white"
              >
                {#if item.isFeatured == false}
                  Feature Template
                {/if}
                {#if item.isFeatured == true}
                  Remove Feature
                {/if}
              </button>
            </div>
            <div class="flex gap-1">
              <button on:click={() => dispatch('devalue-down')}>
                <i class="fa-solid fa-minus" />
              </button>
              <input type="number" value={item.devalueLevel} />
              <button on:click={() => dispatch('devalue-up')}>
                <i class="fa-solid fa-plus" />
              </button>
            </div>
          </div>
        </details>
      {/if}
      <!-- 
            {#if item.isFree == false && $credit.membership.title === MemberShipType.FREE && !isAdmin }
            <WrapperModal forType='template' />
            <span class="absolute top-2 left-2 p-2 rounded-full border-0 z-30">
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="48" height="48" viewBox="0 0 48 48" class="upgrade-modal cursor-pointer">
                    <path fill="#424242" d="M24,4c-5.5,0-10,4.5-10,10v4h4v-4c0-3.3,2.7-6,6-6s6,2.7,6,6v4h4v-4C34,8.5,29.5,4,24,4z"></path><path fill="#FB8C00" d="M36,44H12c-2.2,0-4-1.8-4-4V22c0-2.2,1.8-4,4-4h24c2.2,0,4,1.8,4,4v18C40,42.2,38.2,44,36,44z"></path><path fill="#C76E00" d="M24 28A3 3 0 1 0 24 34A3 3 0 1 0 24 28Z"></path>
                </svg>
            </span>
            {/if} -->
    </div>
    <!--
        {#if isAdmin}
        <div class="grid grid-flow-col rounded-md shadow-sm justify-stretch" role="group">
            <button on:click={() => dispatch('admin-click')} class="px-4 text-sm font-medium py-1 border-2 rounded-md border-red-400 hover:bg-red-400 text-red-400 hover:text-white">
                Delete Template
            </button>
            <button on:click={() => toggleFeature(item)} class="px-4 text-sm font-medium py-1 border-2 rounded-md border-red-400 hover:bg-red-400 text-red-400 hover:text-white">
            {#if item.isFeatured == false}
                Feature Template
            {/if}
            {#if item.isFeatured == true}
                Remove Feature
            {/if}
            </button>
        </div>
        {/if}
            -->
  </div>
  <div
    slot="current_component"
    class="image-item relative flex w-1/4 cursor-pointer flex-col gap-2 text-ellipsis p-2 {isAdmin
      ? 'hover:bg-gray-200'
      : ''}"
  >
    {#if isAdmin}
      <div class="grid grid-flow-col justify-stretch rounded-md shadow-sm" role="group">
        <button
          on:click={() => dispatch('admin-click')}
          class="rounded-md border-2 border-red-400 px-4 py-1 text-sm font-medium text-red-400 hover:bg-red-400 hover:text-white"
        >
          Delete Template
        </button>
        <button
          on:click={() => toggleFeature(item)}
          class="rounded-md border-2 border-red-400 px-4 py-1 text-sm font-medium text-red-400 hover:bg-red-400 hover:text-white"
        >
          {#if item.isFeatured == false}
            Feature Template
          {/if}
          {#if item.isFeatured == true}
            Remove Feature
          {/if}
        </button>
      </div>
    {/if}
    <div
      class="relative h-full w-full rounded-xl {selected.id === item.id
        ? 'shadow-lg outline outline-4 outline-primary'
        : ''}"
    >
      <img
        alt={item.title}
        src={item.src}
        loading="lazy"
        on:load={loadImage}
        on:click={() => dispatch('image-click')}
        on:keydown={() => dispatch('image-click')}
        data-id={item.id}
        id="image-item-{item.id}"
        use:clickOutside
        class="relative z-10 h-full w-full rounded-xl"
      />
      <button
        on:click={() => toggleFavorite(item)}
        id="toggle_favorite"
        class="absolute right-2 top-2 z-20 rounded-full border-0 p-2"
      >
        {#if item.isFavorite == false}
          <span bind:this={favoriteTooltip}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              fill="currentColor"
              class="bi bi-star-fill text-gray-500 hover:text-red-400"
              viewBox="0 0 16 16"
            >
              <path
                d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"
              />
            </svg>
          </span>
        {/if}
        {#if item.isFavorite == true}
          <span bind:this={unFavoriteTooltip}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="32"
              height="32"
              fill="currentColor"
              class="bi bi-star-fill text-red-400 hover:text-gray-500"
              viewBox="0 0 16 16"
            >
              <path
                d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"
              />
            </svg>
          </span>
        {/if}
      </button>
      {#if item.isFree == false && $user.membership === MemberShipType.FREE && !isAdmin}
        <WrapperModal forType="template" />
        <span class="absolute left-2 top-2 z-30 rounded-full border-0 p-2">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            x="0px"
            y="0px"
            width="48"
            height="48"
            viewBox="0 0 48 48"
            class="upgrade-modal cursor-pointer"
          >
            <path
              fill="#424242"
              d="M24,4c-5.5,0-10,4.5-10,10v4h4v-4c0-3.3,2.7-6,6-6s6,2.7,6,6v4h4v-4C34,8.5,29.5,4,24,4z"
            /><path
              fill="#FB8C00"
              d="M36,44H12c-2.2,0-4-1.8-4-4V22c0-2.2,1.8-4,4-4h24c2.2,0,4,1.8,4,4v18C40,42.2,38.2,44,36,44z"
            /><path fill="#C76E00" d="M24 28A3 3 0 1 0 24 34A3 3 0 1 0 24 28Z" />
          </svg>
        </span>
      {/if}
    </div>
  </div>
</FeatureFlag>
